import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ValidationPatterns } from '../constant/constants.type';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }

  /**
   * Validates PAN number format (10 alphanumeric characters)
   */
  static panNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }
    let value = control.value.toUpperCase().trim();

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panRegex.test(value)) {
      return { invalidPan: true }; // Non-digit entered
    }

    return null;
  }

  /**
   * Validates Aadhar number format (12 digits)
   */
  static aadhaarNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }
    const aadharRegex = ValidationPatterns.aadhar;
    if (!aadharRegex.test(control.value)) {
      return { invalidAadhar: true }; // Non-digit entered
    }

    return null;

  }

  /**
   * Validates phone number format (10 digits)
   */
  static phoneNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const onlyDigitsRegex = /^[0-9]{10}$/;

    if (!onlyDigitsRegex.test(control.value)) {
      return { invalidPhone: true }; // Non-digit entered
    }

    return null;
  }

  /**
   * Validates name format (only letters and spaces)
   */
  static nameValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const nameRegex = /^[a-zA-Z\s]+$/;
    return nameRegex.test(control.value) ? null : { invalidName: true };
  }

  static emailValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(control.value)) {
      return { invalidEmail: true }; // Non-digit entered
    }

    return null;
  }

  static alphaNumericValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }
    const alphaNumericRegex = /^[0-9a-zA-Z]+$/;

    if (!alphaNumericRegex.test(control.value)) {
      return { invalidAlphaNumeric: true };
    }

    return null;
  }

  static urlValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // allow empty values, use Validators.required if needed
    }

    const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
    if (!urlRegex.test(control.value)) {
      return { invalidUrl: true }; // Non-digit entered
    }

    return null;
  }

  static numericValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }
    const numericRegex = /^[0-9]*$/;

    if (!numericRegex.test(control.value)) {
      return { invalidNumber: true };
    }

    return null;
  }

  static decimalNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const decimalRegex = /^\d+(\.\d+)?$/;

    if (!decimalRegex.test(control.value)) {
      return { invalidDecimal: true };
    }

    return null;
  }

  static maxPendingValidator(pendingAmount: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = +control.value;
      if (!value && value !== 0) return null;

      if (value > pendingAmount) {
        return { exceedPending: true };
      }
      return null;
    };
  }

}
